import { MailOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import React from 'react';
import { Form, Link } from 'react-router-dom';
//import { emailLogin } from '../../api/auth';
import { resetPassword } from '../../api/auth/login.js';
import { InputWrapper } from '../../components/inputs/input-wrappers.jsx';
import styles from './login.module.scss';
import { Home } from './login.jsx';

const ResetPassword = () => {
    return (
        <Home>
            <Form style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }} method="post">
                <InputWrapper name="email" prefix={<MailOutlined />} placeholder="Email" style={{ borderRadius: 0, fontSize: '1rem' }} required />
                <div className={styles.loginButtonWrapper}>
                    <Link to={-1}><Button type="link" htmlType="submit" className="login-form-button">Cancel</Button></Link>
                    <Button type="primary" htmlType="submit" className="login-form-button">Reset Password</Button>
                </div>
            </Form>
        </Home>
    )
}
ResetPassword.Action = async ({ request }) => {
    const { email } = Object.fromEntries(await request.formData())
    try {
        const msg = await resetPassword(email)
        message.success(msg)
    }
    catch (error) {
        message.error(error.message)
    }
    return false
}

export default ResetPassword